import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const DEFAULTS = {
  home: true, about: true, services: true, iieas: true,
  synapse: true, contact: true, insights: true,
};

const PagesContext = createContext({ pages: DEFAULTS, ready: false, refresh: () => {} });

export function PagesProvider({ children }) {
  const [pages, setPages] = useState(DEFAULTS);
  const [ready, setReady] = useState(false);

  const refresh = async () => {
    try {
      const { data } = await api.get("/content/pages-visibility");
      setPages({ ...DEFAULTS, ...data });
    } catch {
      setPages(DEFAULTS);
    } finally {
      setReady(true);
    }
  };

  useEffect(() => { refresh(); }, []);

  return (
    <PagesContext.Provider value={{ pages, ready, refresh }}>
      {children}
    </PagesContext.Provider>
  );
}

export function usePagesVisibility() {
  return useContext(PagesContext);
}
